<template>
  <b-overlay :show="busy" rounded="sm">

    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable">
        <b-card class="w-100pct">

          <b-card-body class="py-0 px-0">
            <b-tabs class="gridtabs">
              <b-tab>
                <template #title>
                  <div class="badgecontainer pr-2 mr-1">
                    <i :class="icon"></i>
                    {{ title }}
                    <b-badge id="selection" variant="danger" class="edit_tab">
                      {{ selection.length }}</b-badge>
                    <b-tooltip target="selection" placement="bottom">{{ selection.length }}
                      invoice(s)
                      selected</b-tooltip>
                  </div>

                </template>



                <p class="mt-0">
                  <b-row>
                    <b-col>
                      <b-alert :show="true" variant="secondary">
                        <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                            <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                          <b-col>
                            <span class="h6"> The following transactions will be credited on
                              the transaction date selected.
                              Provide further information as to the reason for the credit
                              and indicate how you would
                              like to apply the credit.
                            </span></b-col></b-row>
                      </b-alert></b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="auto">
                      <b-row>
                        <b-col>
                          <b-form-group label-cols="12" label="Transaction Date" label-size="sm">
                            <b-input-group>
                              <b-input-group class="treeselect_all" style="left:90px; top:-13px">
                                <i id="date_at" class="fa fa-info-circle text-black"></i>
                              </b-input-group>
                              <b-tooltip target="date_at" triggers="hover" placement="top">The
                                transaction date you want to post
                                the transaction to
                              </b-tooltip>
                              <daterangepicker size="sm" ref="date_at" v-model="date_at" :opens="'right'"
                                :locale-data="locale_data" :ranges="false" :showDropdowns="true"
                                :linkedCalendars="false" :single-date-picker="'single'">
                              </daterangepicker>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="date_at = {
                                  startDate: $moment().format('YYYY-MM-DD'),
                                  endDate: $moment().format('YYYY-MM-DD'),
                                }
                                  ">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row class="my-2">
                        <b-col cols="12">
                          <b-form-group label-cols="12" label="Reason for Credit?" label-for="reasontype">
                            <b-input-group>
                              <b-form-radio-group class="mt-1 z-0" v-model="reasontype" :options="options_reasontype"
                                name="options_reasontype">
                              </b-form-radio-group>
                            </b-input-group>
                          </b-form-group>

                        </b-col>

                      </b-row>
                      <!-- <b-row class="my-2">
                        <b-col cols="12">
                          <b-form-group label="What to credit?" label-for="selected_option" label-cols="12">
                            <b-form-checkbox-group class="mt-1 z-0" v-model="credit" :options="options_credit"
                              name="options_credit"></b-form-checkbox-group>
                          </b-form-group>
                        </b-col>
                      </b-row>-->
                      <b-row class="my-2">
                        <b-col cols="12">
                          <b-form-group label-cols="12" label="" label-size="sm">
                            <b-form-checkbox id="checkbox-1" v-model="credithold" name="checkbox-1" :value="true"
                              :unchecked-value="false">
                              Return for agent reinvoice
                            </b-form-checkbox>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col>
                      <b-row>
                        <b-col>
                          <b-form-group label-cols="12" label="Transaction(s) selected" label-size="sm"
                            class="mb-0 mt-0">

                            <b-input-group>
                              <b-form-tags input-id="invoiceno" v-model="invoiceno" tag-variant="primary"
                                separator=" ,;" placeholder="" size="sm" class="h-29" add-button-text="+" add-on-change
                                remove-on-delete add-button-variant="outline-primary" :disabled="true"></b-form-tags>

                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="invoiceno = null"
                                  :disabled="true">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-input-group class="mt-3">
                            <b-form-input type="text" v-model="reason" placeholder="Other?" size="sm"
                              :disabled="reasontype == 'other' ? false : true"></b-form-input>
                            <b-input-group-append>
                              <b-button size="sm" :disabled="reasontype == 'other' ? false : true"
                                variant="outline-secondary" @click="reason = ''">
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </p>

              </b-tab>
              <b-tab @click="bl_load">
                <template #title>
                  <i class="fa fa-long-arrow-down text-danger mr-1"></i>
                  Costs</template>
                <p class="py-3 px-0">

                  <b-tabs>
                    <b-tab>
                      <template #title>
                        <div class="badgecontainer pr-1 mr-1 w-60px">
                          <i :class="bl.icon" class="ml-1"></i> Lines
                          <b-badge variant="white" class="edit_tab">
                          </b-badge>

                        </div>
                      </template>
                      <b-row v-if="1 == 0" class="mt-3 mb-3 mx-n3">
                        <b-col cols="auto" class="mr-auto"> <b-list-group horizontal="md" size="sm">
                            <b-list-group-item variant="dark"><span class="list-label">To:
                                {{ item.slac }}</span> {{ item.to }}</b-list-group-item>
                            <b-list-group-item variant="dark"><span class="list-label">Your
                                Ref/PO:</span>{{ item.yourref }}</b-list-group-item>
                            <b-list-group-item variant="dark"><span class="list-label">Invoice
                                No:</span>{{ item.invoiceno }}</b-list-group-item>
                            <b-list-group-item variant="dark"><span class="list-label">Issued:</span>{{
                              $moment.unix(item.dateref * 0.001).format("DD/MM/YYYY")
                            }}</b-list-group-item>
                            <b-list-group-item variant="dark"><span class="list-label">Due
                                on:</span>{{ $moment.unix(item.datedue *
                                  0.001).format("DD/MM/YYYY")
                                }}</b-list-group-item>

                          </b-list-group></b-col>
                        <b-col cols="auto"> <b-list-group horizontal="md" size="sm">

                            <b-list-group-item variant="dark-danger"><span class="list-label">Credit:</span>{{
                              credited.toFixed(2) |
                              currency("")
                            }}</b-list-group-item>

                          </b-list-group></b-col>

                      </b-row>
                      <b-row>
                        <b-col>
                          <d-table classdivtable="availtable datatable nested footertotal_danger" refid="bl"
                            :icon="bl.icon" :selectmode="'multi'" :busy="bl.busy" :tools="bl.tools" :badges="bl.badges"
                            :fields="bl.fields" :selectall="bl.selectall" :items="bl.items" :page="bl.page"
                            :showpages="false" @load="bl_load" @click="bl_click" @select="bl_select">
                          </d-table>
                          <div v-if="component">
                            <component :is="component" :selection="bl.selected" :config="cconfig"
                              @discard="bl_click('discard')" @refresh="bl_click('refresh')"></component>
                          </div>
                        </b-col>
                      </b-row>
                      <b-tabs v-if="bl.item.line" class="gridtabs mt-2">


                        <b-tab>
                          <template #title>
                            <span class="text-primary">{{bl.items.map(o =>
                              o.line).indexOf(bl.item.line) + 1
                            }}.</span>
                            <i :class="'fa fa fa-arrows-h text-info'" class="text-primary ml-1 mr-1"></i>
                            <span class="text-warning">&lt;{{ selection.length == 0 ? "new"
                              : "edit" }}&gt;</span>&nbsp;


                          </template>

                          <p class="py-3 px-0">
                            <b-row>

                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Ticket No/Ref" label-size="sm">
                                  <b-input-group>
                                    <b-form-input v-model="bl.item.ticketno" :debounce="sl.debounce"
                                      placeholder="Ticket No" :disabled="readonly"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                        @click="bl.item.ticketno = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>

                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Passenger / Comments" label-size="sm">
                                  <b-input-group>
                                    <b-form-input v-model="bl.item.passenger" :debounce="sl.debounce"
                                      placeholder="Name / Comments" :disabled="false"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" :disabled="!bl.item.passenger"
                                        @click="bl.item.passenger = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>

                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Route" label-for="route" label-cols="12">
                                  <b-input-group>
                                    <b-form-input type="text" v-model="bl.item.route" placeholder="Route" size="sm" trim
                                      :disabled="readonly"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="bl.item.route = ''"
                                        :disabled="readonly">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>

                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Remark" label-for="remark" label-cols="12">
                                  <b-input-group>
                                    <!-- v-model="bl.item.remark" -->
                                    <b-form-input type="text" placeholder="Remark" size="sm" trim
                                      :disabled="true"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" variant="outline-secondary" @click="bl.item.remark = ''"
                                        :disabled="true">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>

                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="DateTravel" label-size="sm">
                                  <b-input-group>
                                    <v-date-picker v-model="bl.item.datetravel" mode="date" is24hr color="green"
                                      :locale="'en-gb'" class="form-control form-control-sm" :disabled="readonly">
                                      <template v-slot="{ inputValue, inputEvents }">
                                        <input :disabled="readonly" class="h-19px border-none
                                                                                              focus:outline-none focus:border-primary
                                                                                              text-primary"
                                          :value="inputValue" v-on="inputEvents" />
                                      </template>
                                    </v-date-picker>
                                    <b-input-group-append>
                                      <b-button size="sm" squared variant="outline-secondary" :disabled="readonly"
                                        @click="bl.item.datetravel = null">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>



                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Supplier B/L" label-size="sm">
                                  <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..."
                                    v-model="bl.item.blac" :clearable="true" :async="true"
                                    :load-options="treeselect_loadBLAC" :show-count="true"
                                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                    search-nested :disabled="readonly">
                                    <div slot="value-label" slot-scope="{ node }">
                                      {{ node.raw.id }}
                                    </div>
                                  </treeselect>
                                </b-form-group>
                              </b-col>


                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Qty" label-for="qty" label-cols="12">
                                  <b-input-group>
                                    <b-form-input type="text" v-model="bl.item.qty" placeholder="Qty" size="sm"
                                      :disabled="readonly"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                                        @click="bl.item.qty = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>

                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Cost Ex VAT" label-for="costexvat" label-cols="12">
                                  <b-input-group>
                                    <b-form-input type="text" v-model="bl.item.costexvat" placeholder="Cost" size="sm"
                                      :disabled="readonly"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                                        @click="bl.item.costexvat = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Cost VAT" label-for="vat" label-cols="12">
                                  <b-input-group>
                                    <b-form-input type="text" v-model="bl.item.costvat" placeholder="VAT" size="sm"
                                      :disabled="readonly"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                                        @click="bl.item.costvat = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Taxes" label-for="taxes" label-cols="12">
                                  <b-input-group>
                                    <b-form-input type="text" v-model="bl.item.taxes" placeholder="Taxes" size="sm"
                                      :disabled="readonly"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                                        @click="bl.item.taxes = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Cost Total" label-for="costtotal" label-cols="12">
                                  <b-input-group>
                                    <b-form-input type="text" v-model="bl.item.costtotal" placeholder="Cost Total"
                                      size="sm" :disabled="readonly"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                                        @click="bl.item.costtotal = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>



                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                                    v-model="item.slac" :clearable="true" :async="true"
                                    :load-options="treeselect_loadSLAC" :show-count="true"
                                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                    search-nested :disabled="readonly">
                                    <div slot="value-label" slot-scope="{ node }">
                                      {{ node.raw.id }}
                                    </div>
                                  </treeselect>
                                </b-form-group>
                              </b-col>
                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Event" label-size="sm">
                                  <treeselect placeholder="Select event..." v-model="item.eventcode" :clearable="true"
                                    :async="true" :load-options="treeselect_loadEvent"
                                    searchPromptText="Type at least 4 chars..." :show-count="true"
                                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                    search-nested :disabled="readonly">
                                    <div slot="value-label" slot-scope="{ node }">
                                      {{ node.raw.id }}
                                    </div>
                                  </treeselect>
                                </b-form-group>
                              </b-col>
                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="BSP Ref" label-for="bspref" label-cols="12">
                                  <b-input-group>
                                    <b-form-input type="text" v-model="bl.item.bspref" placeholder="BSP Ref" size="sm"
                                      :disabled="readonly"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" :disabled="readonly" variant="outline-secondary"
                                        @click="bl.item.bspref = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>



                            </b-row>
                            <b-row>
                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Entry" label-for="entry" label-cols="12">
                                  <b-input-group>
                                    <b-form-input type="text" v-model="bl.item.entry" placeholder="Entry" size="sm"
                                      :disabled="true"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" :disabled="true" variant="outline-secondary"
                                        @click="bl.item.entry = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Accounting Period" label-for="ap" label-cols="12">
                                  <b-input-group>
                                    <b-form-input type="text" v-model="item.ap" placeholder="Accounting Period"
                                      size="sm" :disabled="true"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" :disabled="true" variant="outline-secondary"
                                        @click="item.ap = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Period" label-for="period" label-cols="12">
                                  <b-input-group>
                                    <b-form-input type="text" v-model="item.period" placeholder="Period" size="sm"
                                      :disabled="true"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" :disabled="true" variant="outline-secondary"
                                        @click="item.period = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>

                              <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Age" label-for="age" label-cols="12">
                                  <b-input-group>
                                    <b-form-input type="text" v-model="item.age" placeholder="Age" size="sm"
                                      :disabled="true"></b-form-input>
                                    <b-input-group-append>
                                      <b-button size="sm" :disabled="true" variant="outline-secondary"
                                        @click="item.age = ''">
                                        <i class="fa fa-remove"></i>
                                      </b-button>
                                    </b-input-group-append>
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                            </b-row>

                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Airline" label-for="airline"
                  label-cols="12">
                  <b-input-group>
                      <b-form-input type="text"
                          v-model="bl.item.airline"
                          placeholder="Airline" size="sm"
                          :disabled="readonly"></b-form-input>
                      <b-input-group-append>
                          <b-button size="sm" :disabled="readonly"
                              variant="outline-secondary"
                              @click="bl.item.airline = ''">
                              <i class="fa fa-remove"></i>
                          </b-button>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Tour" label-for="tour" label-cols="12">
                  <b-input-group>
                      <b-form-input type="text" v-model="bl.item.tour"
                          placeholder="Tour" size="sm"
                          :disabled="readonly"></b-form-input>
                      <b-input-group-append>
                          <b-button size="sm" :disabled="readonly"
                              variant="outline-secondary"
                              @click="bl.item.tour = ''">
                              <i class="fa fa-remove"></i>
                          </b-button>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group>
          </b-col> -->
                            <!-- <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="VAT Code" label-cols="12">
                  <treeselect v-model="bl.item.vatcode"
                      :clearable="false" :options="vatcode_options"
                      :disabled="readonly">
                  </treeselect>
              </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Cost A/C" label-for="costac"
                  label-cols="12">
                  <b-input-group>
                      <b-form-input type="text"
                          v-model="bl.item.costac"
                          placeholder="Cost A/C" size="sm"
                          :disabled="readonly"></b-form-input>
                      <b-input-group-append>
                          <b-button size="sm" :disabled="readonly"
                              variant="outline-secondary"
                              @click="bl.item.costac = ''">
                              <i class="fa fa-remove"></i>
                          </b-button>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Control A/C" label-for="controlac"
                  label-cols="12">
                  <b-input-group>
                      <b-form-input type="text"
                          v-model="bl.item.controlac"
                          placeholder="Control A/C" size="sm"
                          :disabled="readonly"></b-form-input>
                      <b-input-group-append>
                          <b-button size="sm" :disabled="readonly"
                              variant="outline-secondary"
                              @click="bl.item.controlac = ''">
                              <i class="fa fa-remove"></i>
                          </b-button>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group>
          </b-col>

       
      </b-row> -->


                          </p>

                        </b-tab>

                      </b-tabs>

                    </b-tab>

                  </b-tabs>


                </p>
              </b-tab>

              <b-tab v-if="reasontype == 'reinvoice'">
                <template #title>
                  <i class="fa fa-long-arrow-up text-primary mr-1"></i>
                  Reinvoice</template>
                <p class="py-3 px-0">
                  <b-row class="mb-4"><b-col>
                      The following details can be changed for the new invoices, or if these
                      values
                      are left empty they will keep the values of the old invoices.
                    </b-col>

                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Your Ref / PO" label-for="yourref" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="yourref" placeholder="Your Ref / PO" size="sm"
                            :disabled="false"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="false" variant="outline-secondary"
                              @click="item.yourref = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                        <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                          v-model="slac" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                          :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                          :matchKeys="['id']" search-nested :disabled="false">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Event" label-size="sm">
                        <treeselect placeholder="Select event..." v-model="eventcode" :clearable="true" :async="true"
                          :load-options="treeselect_loadEvent" searchPromptText="Type at least 4 chars..."
                          :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                          :matchKeys="['id']" search-nested :disabled="false">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>
                      </b-form-group>
                    </b-col>

                  </b-row>


                </p>
              </b-tab>


            </b-tabs>

          </b-card-body>
          <b-card-footer class="nopadding mt-2">
            <b-row no-gutters>
              <b-col cols="auto" class="text-left">
                <b-button squared size="sm" variant="primary" :disabled="posted" @click="saveit()"
                  v-if="user.permissions.includes('boughtledger.save')">
                  <i class="fa fa-check"></i>
                  Post It
                </b-button>
              </b-col>
              <b-col class="text-left mt-1 ml-2">
                <div v-if="busy">
                  <i class="fa fa-spinner fa-spin text-primary"></i>
                </div>
                <div v-else>
                  <span v-html="message"></span>
                </div>
              </b-col>

              <b-col class="text-right">
                <b-button squared size="sm" variant="secondary" @click="discard">
                  <i class="fa fa-chevron-left pr-1"></i>
                  Back
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "BLCredit",
  async mounted() {
    this.item.agent = this.user.initials;

  },
  data() {
    return {
      title: "Credit",
      icon: "fa fa-undo text-danger mr-1",
      busy: false,
      date_at: {
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      posted: false,
      invoiceno: [],
      yourref: null,
      slac: null,
      eventcode: null,
      reason: null,
      item: {},
      credited: 0,
      credithold: false,
      reasontype: 'credit',
      options_reasontype: [
        { text: 'Credit', value: 'credit', },
        // { text: 'Reinvoice', value: 'reinvoice', },
        { text: 'Void', value: 'void' },
        //    { text: 'Refund', value: 'Refund', disabled: true },
        { text: 'Other', value: 'other' },
      ],
      reason: null,
      credit: ['creditbl'],
      options_credit: [
        { text: 'Sales', value: 'creditsl' },
        { text: 'Fees', value: 'creditfees', },
        { text: 'Costs', value: 'creditbl' },
      ],
      bl: {
        icon: "fa fa-list text-danger",
        debounce: 500,
        busy: false,
        selectall: false,
        tools: "go,clipboard",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px text-primary",
          },
          {
            key: "ticketno",
            label: "Ticket / Item",
            sortable: true,
            class: "d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 10) {
                  result = result.slice(0, 12) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "passenger",
            label: "Name / Comments",
            sortable: true,
            class: "d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 30) {
                  result = result.slice(0, 27) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
              }
              return result;
            },
          },
          {
            key: "route",
            label: "Route",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "qty",
            label: "Qty",
            sortable: true,
            class: "text-right",
          },
          {
            key: "lineprice",
            label: "Cost Ex Vat",
            sortable: true,
            class: "text-right",
            total: 0,
            totalled: true,
          },
          {
            key: "linetaxes",
            label: "Taxes",
            sortable: true,
            class: "text-right",
            total: 0,
            totalled: true,
          },
          {
            key: "linetotal",
            label: "Cost Total",
            sortable: true,
            class: "text-right",
            total: 0,
            totalled: true,
          },
          // {
          //     key: "invoiceno",
          //     label: "InvoiceNo",
          //     sortable: true,
          //     class: "text-right w-80px",
          // },
          // {
          //     key: "dateref",
          //     label: "Date",
          //     sortable: true,
          //     class: "text-center",
          //     formatter: (value, key, item) => {
          //         let result = "";
          //         if (value) {
          //             result = this.$moment
          //                 .unix(value / 1000)
          //                 .format("DD/MM/YYYY HH:mm");
          //         }
          //         return result;
          //     },
          // },
          // {
          //     key: "blac",
          //     label: "BL A/C",
          //     sortable: true,
          //     class: "d-none d-sm-table-cell",
          // },
          // {
          //     key: "slac",
          //     label: "SL A/C",
          //     sortable: true,
          //     class: "d-none d-sm-table-cell",
          // },
          // {
          //     key: "eventcode",
          //     label: "Event",
          //     sortable: true,
          //     class: "d-none d-sm-table-cell",
          // },


          // {
          //     key: "outstanding",
          //     label: "Paid",
          //     sortable: true,
          //     class: "text-right",
          //     formatter: (value, key, item) => {
          //         if (value) {
          //             return parseFloat(value).toFixed(2);
          //         } else {
          //             return value;
          //         }
          //     },
          //     totalled: true,
          //     total: 0,
          // },
          // {
          //     key: "costtotal",
          //     label: "Due",
          //     sortable: true,
          //     class: "text-right",
          //     formatter: (value, key, item) => {
          //         if (value) {
          //             return parseFloat(value).toFixed(2);
          //         } else {
          //             return value;
          //         }
          //     },
          //     totalled: true,
          //     total: 0,
          // },


          // {
          //     key: "refcredit",
          //     label: "Cr Ref",
          //     sortable: true,
          //     class: "d-none d-sm-table-cell",
          // },
          // {
          //     key: "credit",
          //     label: "Type",
          //     sortable: true,
          //     class: "text-center d-none d-sm-table-cell",
          // },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-right",
            // formatter: (value, key, item) => {
            //   let result = "Never";
            //   if (value) {
            //     result = this.$moment
            //       .unix(value / 1000)
            //       .format("DD/MM/YYYY hh:mm");
            //   }
            //   return result;
            // },
          },

        ],
        badges: [],
        item: {},
        items: [],
        selected: []
      }
    };
  },
  computed: {
    readonly() {
      if (this.user.permissions.includes('boughtledger.save')) {
        return false
      }
      return true;
    },
  },
  methods: {
    async load() {
      this.invoiceno = []
      for (var i = 0; i < this.selection.length; ++i) {
        this.invoiceno.push(this.selection[i].invoiceno)
      }
      if (this.selection.length == 1) {
        await this.bl_load();
      }
    },

    async bl_load(offset, limit, page) {

      if (page) {
        this.bl.page = page
      }

      this.bl.busy = true;

      let variables = {
        reflist: this.selection.map(o => o.invoiceno).join(","),
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
              query BLTransactions($reflist: String) {
                  BLTransactions(reflist: $reflist) {
                      id
                      invoiceno
                      entry
                      ref
                      yourref
                      dateref
                      to
                      blac
                      slac
                      eventcode
                      outstanding
                      refcredit
                      passenger
                      ticketno
                      route
                      datetravel
                      qty
                      lineprice
                      linetaxes
                      linetotal
                      updated_at
                      updated_by
                      credit
                      datepaid
                  }
              }
          `,
          variables,
        });

        this.bl.items = response.data.BLTransactions

      } catch (error) {
        console.log(error);
      }
      this.bl.busy = false;
    },
    async bl_click(a, ss) {
      console.log("bl_click", a, ss);

      let state = this.bl;

      switch (a) {
        case "selectall":
          this.bl.selectall = !this.bl.selectall;
          break;
        case "go":
          this.component = null;
          await this.bl_load();
          break;

        case "save":
          await this.bl_saveit()
          break;

      }
    },
    async bl_select(ss, tools) {
      console.log("bl_select", ss);

      let state = this.bl;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "go", "filter", "add", "export", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "notes"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["save", "deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }

      // this.credited = 0
      // if (state.selected.length > 0) {
      //     let value = 0
      //     state.selected.forEach(function (action, index) {
      //         value += parseFloat(state.selected[index].saletotal)
      //     })
      //     this.credited = value
      // } else {
      //     state.item = {}
      // }

      if (state.selected.length > 0) {
        state.item = { ...state.selected[0] }  // WHAT YOU SELECTED
        state.item.datetravel = this.$moment.unix(state.item.datetravel * 0.001).utc(true).format("YYYY-MM-DD")
        state.item.ticketno = state.item.ticketno.split(',')
      } else {
        state.item = {}
      }
    },

    async saveit() {
      this.busy = true;

      let ss = this.selection

      let rows = []
      for (var i = 0; i < ss.length; ++i) {
        rows.push({
          id: ss[i].counter,
        })
      }

      let actions = this.credit
      if (this.credithold) { actions.push('creditzhold') }

      let variables = {
        rows,
        options: JSON.stringify({
          actions,
          date_at: this.date_at,
          reasontype: this.reasontype,
          reason: this.reason ? this.reason : this.reasontype,
        })
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation BL_credit($rows: [BLTransaction_input], $options:String) {
                BL_credit(rows: $rows, options: $options) {
                    id
                    invoiceno
                }
            }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Posted it. " + [... new Set(response.data.BL_credit.map(o => o.invoiceno))].join(", ") + " </span>";
        this.posted = true

      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;

    },


  },
};
</script>